$(".announcement-bar-static .top-bar__slider").slick({
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 3000,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  centerMode: false,
  arrows: false
});


$("[data-oke-reviews-product-listing-rating]").click(function(e) {
  e.preventDefault();
  const reviewsWidget = $("[data-oke-reviews-widget-holder]");
  
  if (reviewsWidget.length > 0) {
    const headerOffset = 100;
    const scrollPosition = reviewsWidget.offset().top - headerOffset;
    $('html, body').animate({
      scrollTop: scrollPosition
    }, 800);
  }
});